import axios from '../axios'

const deleteQuizApi = async (quizId) => {
  return await axios.delete(`api/lms/quizzes/${quizId}`)
}

export default deleteQuizApi
